import React from 'react';

import ProcurementPoliciesTable from '../../procurement_policies/ProcurementPoliciesTable';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementPolicyTab = () => {
    const { routes } = useProcurement();

    return (
        <ProcurementPoliciesTable
            indexUrl={routes.fetchPoliciesUrl}
            createUrl={routes.createPolicyUrl}
            updateUrl={routes.updatePolicyUrl}
            deleteUrl={routes.deletePolicyUrl}
        />
    );
};

export default ProcurementPolicyTab;
